import React from 'react'
import { pdf } from '@react-pdf/renderer'
import RoutePDFDocument from './RoutePDFDocument'
import { Router } from '../../../contexts/RouterContext'

export async function printRoutePdf(router: Router): Promise<void> {
  const blob = await pdf(<RoutePDFDocument router={router} />).toBlob()
  const url = URL.createObjectURL(blob)

  const iframe = document.createElement('iframe')
  iframe.style.position = 'fixed'
  iframe.style.right = '0'
  iframe.style.bottom = '0'
  iframe.style.width = '0'
  iframe.style.height = '0'
  iframe.style.border = 'none'
  iframe.src = url
  document.body.appendChild(iframe)

  iframe.onload = () => {
    iframe.contentWindow?.focus()
    iframe.contentWindow?.print()
    setTimeout(() => {
      document.body.removeChild(iframe)
      URL.revokeObjectURL(url)
    }, 1000)
  }
}
